/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { decodeHTML } from 'entities';

import mbpLogger from 'mbp-logger';

import * as dataLayerProductHelpers from '../../product/dataLayerProductHelpers';
import { dateStringReformat } from '../../../../components/GraphqlComponents/GraphqlProductPage/Partials/common/commonProductPageHelper';

// Build Product arrays
export const generateDataLayerProductArrays = ({
    inStock = false,
    products,
    impressions = false,
    props = {},
}) => {
    const MAX_PRODUCT_COUNT = 20;
    const tempDataLayer = {};

    // Products
    const productIds = [];
    const productNames = [];
    const productPrices = [];
    const productSkus = [];
    const productBaseCodes = [];
    const productBrands = [];
    const productCategoryIds = [];
    const productCategoryLegacyIds = [];
    const productCategoryNames = [];
    const productCategoryPaths = [];
    const productVariants = [];
    const productListNames = [];
    const productListPositions = [];
    const productQuantities = [];
    const productIsShipInFuture = [];
    const productShipDate = [];
    const productBrandsName = [];

    const productCurrency = [];
    const productHasWine = [];
    const productImageUrls = [];
    const productInStock = [];
    // Impressions
    const productImpressionBrands = [];
    const productImpressionBrandsName = [];
    const productImpressionCategoryIds = [];
    const productImpressionCategoryLegacyIds = [];
    const productImpressionCategoryNames = [];
    const productImpressionCategoryPaths = [];
    const productImpressionIds = [];
    const productImpressionBaseCodes = [];
    const productImpressionListNames = [];
    const productImpressionListPositions = [];
    const productImpressionNames = [];
    const productImpressionSkus = [];
    const productImpressionPrices = [];
    const productImpressionVariants = [];
    const productImpressionShipDate = [];
    const productImpressionShipInFuture = [];

    const productImpressionCurrency = [];
    const productImpressionHasWine = [];

    // subscriptions
    const productSubscriptionDuration = [];
    const productSubscriptionType = [];
    const productSubscriptionInterval = [];

    const tld = typeof window !== 'undefined' && window.location && (window.location.hostname?.split?.('.').pop() || '');

    try {
        const { category } = props;
        Object.keys(products).forEach((key, idx) => {
            try {
                // Limit Product list to MAX_PRODUCT_COUNT
                if (idx < MAX_PRODUCT_COUNT) {
                    const product = products[key];
                    const skus = (product.sKUs) ? product.sKUs.map((sku) => sku.partNumber) : [product.selectedSku || product.partNumber];
                    const addons = (product?.addOns || []).map((item) => item);

                    // Valid product
                    if (dataLayerProductHelpers.isValidProduct(product)) {
                        // Allow for seeding product list position
                        const productCount = props.productListPositionSeed ? ((idx + props.productListPositionSeed) + 1) : (idx + 1);

                        const selectedSkuData = product?.productSkus?.find?.((item) => item?.id === product?.selectedSku) || null;

                        const isWineProduct = selectedSkuData?.ageVerifyFlag === 'true' || product?.ageVerifyFlag === 'true';
                        // Impressions (Category / Search / UpSells / AddOns / Components)
                        if (impressions) {
                            productImpressionIds.push(dataLayerProductHelpers.getBaseCode(product.partNumber || ''));
                            productImpressionNames.push(decodeHTML(product.name) || '');
                            productImpressionBaseCodes.push(product.baseCode || dataLayerProductHelpers.getBaseCode(product.partNumber) || '');
                            productImpressionPrices.push(dataLayerProductHelpers.getPrice(product) || '');
                            productImpressionSkus.push(...skus || '');
                            if (product?.variant) {
                                productImpressionVariants.push(product.variant || '');
                            } else {
                                productImpressionVariants.push(...skus || '');
                            }

                            productImpressionBrands.push(product.brandId || dataLayerProductHelpers.getBrandId(product.partNumber) || product.brand || '');
                            productImpressionBrandsName.push(product?.brand?.concat?.('.', tld) || '');
                            productImpressionListPositions.push(productCount || '');
                            productImpressionCurrency.push(product.currency || 'USD');
                            productImpressionHasWine.push(isWineProduct ? 'yes' : 'no');

                            if (category) { // Category-Based
                                productImpressionCategoryIds.push(category.id || '');
                                productImpressionCategoryLegacyIds.push(category.legacyId || category.id ||  '');
                                productImpressionCategoryNames.push(decodeHTML(category.shortDescription || category.name  || ''));
                                productImpressionCategoryPaths.push(category.path || category.categoryPath || '');
                            } else { // Product-Based
                                productImpressionCategoryIds.push(product.categoryId || '');
                                productImpressionCategoryLegacyIds.push(product.categoryLegacyId || product.categoryId ||  '');
                                productImpressionCategoryNames.push((product.categoryName) ? decodeHTML(product.categoryName) : '');
                                productImpressionCategoryPaths.push(product.categoryPath || '');
                            }

                            if (product.categoryName || product.list) {
                                productImpressionListNames.push(product.list || product.categoryName || '');
                            } else if (props.searchTerm) {
                                productImpressionListNames.push(`Search: ${props.searchTerm}` || '');
                            }

                            // DIM113 & 114
                            if (product?.availability?.earliestShipDate) {
                                const shipmentData = dateStringReformat(product?.availability?.earliestShipDate, true);
                                const isFuture = (new Date() < new Date(shipmentData?.year, shipmentData?.month, shipmentData?.day));
                                productImpressionShipDate.push(isFuture ? dateStringReformat(product?.availability?.earliestShipDate) : '');
                                productImpressionShipInFuture.push(isFuture ? 'Yes' : 'No');
                            } else {
                                productImpressionShipDate.push('');
                                productImpressionShipInFuture.push('');
                            }
                        } else {
                            productIds.push(dataLayerProductHelpers.getBaseCode(product.partNumber) || '');
                            productNames.push(decodeHTML(product.name) || '');
                            productPrices.push(dataLayerProductHelpers.getPrice(product) || '');
                            productSkus.push(...skus || ''); // TODO: DATALAYER - Find skus
                            productImageUrls.push(product?.image?.path);
                            productInStock.push(inStock);
                            if (product?.variant) {
                                productVariants.push(product.variant || '');
                            } else {
                                productVariants.push(...skus || '');
                            }
                            productBaseCodes.push(product.baseCode || dataLayerProductHelpers.getBaseCode(product.partNumber) || '');
                            productBrands.push(product.brandId || dataLayerProductHelpers.getBrandId(product.partNumber) || product.brand || '');
                            productBrandsName.push(product?.brand?.concat?.('.', tld) || '');
                            productListPositions.push(productCount || '');
                            productQuantities.push(product.quantity || 1); // by default added 1

                            productCurrency.push(product.currency || 'USD');
                            productHasWine.push(isWineProduct ? 'yes' : 'no');

                            if (addons?.length > 0) {
                                (addons || []).forEach((item) => {
                                    productIds.push(dataLayerProductHelpers.getBaseCode(item.baseCode) || '');
                                    productNames.push(decodeHTML(item.productName) || '');
                                    productPrices.push(dataLayerProductHelpers.getPrice({ price: item.price || '' }));
                                    productSkus.push(item.sku || '');
                                    productBaseCodes.push(dataLayerProductHelpers.getBaseCode(item.baseCode) || '');
                                    productBrands.push(item.brandCode);
                                    productBrandsName.push(item?.brand?.concat?.('.', tld) || '');
                                    productQuantities.push(item.quantity || 1); // by default added 1
                                    productCurrency.push(item.currency || 'USD');
                                });
                            }

                            if (category) { // Category-Based
                                productCategoryIds.push(category.id || '');
                                productCategoryLegacyIds.push(category.legacyId || category.id  || '');
                                productCategoryNames.push(decodeHTML(category.shortDescription || category.name || ''));
                                productCategoryPaths.push(category.path || category.categoryPath || '');
                            } else { // Product-Based
                                productCategoryIds.push(product.categoryId || '');
                                productCategoryLegacyIds.push(product.categoryLegacyId || product.categoryId || '');
                                productCategoryNames.push((product.categoryName) ? decodeHTML(product.categoryName) : '');
                                productCategoryPaths.push(product.categoryPath || '');
                            }

                            if (product.categoryName || category) {
                                productListNames.push(product.categoryName || decodeHTML(category?.shortDescription || '') || 'CYO Components');
                            }

                            if (props.searchTerm) {
                                productListNames.push(`Search: ${props.searchTerm}` || '');
                            }

                            // DIM113 & 114
                            if (product?.availability?.earliestShipDate) {
                                const shipmentData = dateStringReformat(product?.availability?.earliestShipDate, true);
                                const isFuture = (new Date() < new Date(shipmentData?.year, shipmentData?.month, shipmentData?.day));
                                productShipDate.push(isFuture ? dateStringReformat(product?.availability?.earliestShipDate) : '');
                                productIsShipInFuture.push(isFuture ? 'Yes' : 'No');
                            } else {
                                productShipDate.push('');
                                productIsShipInFuture.push('');
                            }

                            // Subscription feeding to DL
                            productSubscriptionType.push(product?.subscription?.type || '');
                            productSubscriptionDuration.push(product?.subscription?.duration || '');
                            productSubscriptionInterval.push(product?.subscription?.interval || '');
                        }
                    }
                }
            } catch (ex) {
                mbpLogger.logError({
                    products,
                    impressions,
                    props,
                    function: 'generateDataLayerProductArrays',
                    appName: process.env.npm_package_name,
                    module: 'mbp-page',
                    jsError: ex,
                    message: 'Failed to add product to product arrays.',
                });
            }
        });

        // Impressions (Displayed to the customer)
        if (productImpressionIds.length) {
            tempDataLayer.product_imp_ids = productImpressionIds || [''];
            tempDataLayer.product_imp_base_codes = productImpressionBaseCodes || [''];
            tempDataLayer.product_imp_brands = productImpressionBrands || [''];
            tempDataLayer.product_imp_brands_name = productImpressionBrandsName || [''];
            tempDataLayer.product_imp_category_ids = productImpressionCategoryIds || [''];
            tempDataLayer.product_imp_category_legacy_ids = productImpressionCategoryLegacyIds || [''];
            tempDataLayer.product_imp_category_names = productImpressionCategoryNames || [''];
            tempDataLayer.product_imp_category_paths = productImpressionCategoryPaths || [''];
            tempDataLayer.product_imp_categories = productImpressionCategoryPaths || [''];
            tempDataLayer.product_imp_list_names = productImpressionListNames || [''];
            tempDataLayer.product_imp_list_positions = productImpressionListPositions || [''];
            tempDataLayer.product_imp_names = productImpressionNames || [''];
            tempDataLayer.product_imp_prices = productImpressionPrices || [''];
            tempDataLayer.product_imp_skus = productImpressionSkus || [''];
            tempDataLayer.product_imp_sku_ids = productImpressionSkus || [''];
            tempDataLayer.product_imp_variants = productImpressionVariants || [''];
            tempDataLayer.product_imp_currency = productImpressionCurrency || [''];
            // Dim113 & 114
            tempDataLayer.product_imp_is_future_dated = productImpressionShipDate;
            tempDataLayer.product_imp_future_date = productImpressionShipInFuture;
            tempDataLayer.product_imp_has_wine = productImpressionHasWine || [''];
        } else {
            tempDataLayer.product_ids = productIds || [''];
            tempDataLayer.product_names = productNames || [''];
            tempDataLayer.product_prices = productPrices || [''];
            tempDataLayer.product_sku_ids = productSkus || [''];
            tempDataLayer.product_skus = productSkus || [''];
            tempDataLayer.product_variants = productVariants || [''];
            tempDataLayer.product_base_codes = productBaseCodes || [''];
            tempDataLayer.product_brands = productBrands || [''];
            tempDataLayer.product_brands_name = productBrandsName || [''];
            tempDataLayer.product_category_ids = productCategoryIds || [''];
            tempDataLayer.product_category_legacy_ids = productCategoryLegacyIds || [''];
            tempDataLayer.product_category_names = productCategoryNames || [''];
            tempDataLayer.product_category_identifiers = productCategoryNames || [''];
            tempDataLayer.product_category_paths = productCategoryPaths || [''];
            tempDataLayer.product_categories = productCategoryPaths || [''];
            tempDataLayer.product_quantities = productQuantities || [''];
            tempDataLayer.product_list_names = productListNames || [''];
            tempDataLayer.product_list_positions = productListPositions || [''];
            tempDataLayer.product_has_wine = productHasWine || [''];
            tempDataLayer.product_image_urls = productImageUrls || [''];
            tempDataLayer.in_stock = inStock || [''];

            tempDataLayer.product_list_currency = productCurrency || [''];
            // Dim113 & 114
            tempDataLayer.product_is_future_dated = productShipDate;
            tempDataLayer.product_future_date = productIsShipInFuture;

            // subscription
            tempDataLayer.product_subscription_type = productSubscriptionType;
            tempDataLayer.product_subscription_interval = productSubscriptionInterval;
            tempDataLayer.product_subscription_duration = productSubscriptionDuration;
        }
    } catch (ex) {
        mbpLogger.logError({
            products,
            impressions,
            props,
            function: 'generateDataLayerProductArrays',
            appName: process.env.npm_package_name,
            module: 'mbp-page',
            jsError: ex,
            message: 'Failed to generate product arrays.',
        });
    }

    return tempDataLayer;
};

export const convertPassportDataToProduct = (passport) => {
    const passportItem = passport?.item_id || null;
    if (passportItem) {
        const item = {};
        item[passportItem] = {
            brandId: passport?.brand_id || '',
            baseCode: passport?.item_id || '',
            partNumber: passport?.item_id,
            name: 'Passport',
            price: passport?.price,
            sKUs: [{ partNumber: passport?.item_id || '' }],
        };
        return item;
    }
    return {};
};

export const convertToProduct = (list) => {
    const products = {};
    if (list) {
        list.forEach((item) => {
            products[item.id] = item;
        });
    }
    return products;
};

export const convertMoviesDataToProduct = (movies) => {
    const movieProducts = {};
    (movies || []).forEach((movie) => {
        const movieSku = movie?.sku || null;
        movieProducts[movieSku] = {
            brandId: movie?.brand_id || '',
            baseCode: movie?.sku || '',
            partNumber: movie?.sku,
            name: `NBCU-${movie?.sku}`, // movie?.sku_description,
            price: movie?.sku_price,
            sKUs: [{ partNumber: movie?.sku || '' }],
        };
    });

    return movieProducts;
};
export default {
    generateDataLayerProductArrays,
    convertPassportDataToProduct,
    convertMoviesDataToProduct,
};
